// src/components/ModeloDestacado/ModeloDestacado.jsx
import React, { useEffect, useState, useRef } from 'react'
import Slider from 'react-slick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import ModeloDestacadoCard from './ModeloDestacadoCard'
import styles from './ModeloDestacado.module.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const PrevArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={className}
    style={{
      ...style,
      backgroundColor: '#aace3b',
      borderRadius: '50%',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      border: 'none',
      cursor: 'pointer',
      zIndex: 2,
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faChevronLeft} color="#fff" />
  </button>
)

const NextArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={className}
    style={{
      ...style,
      backgroundColor: '#aace3b',
      borderRadius: '50%',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      border: 'none',
      cursor: 'pointer',
      zIndex: 2,
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faChevronRight} color="#fff" />
  </button>
)

const ModeloDestacado = () => {
  const [items, setItems] = useState([])
  const [error, setError] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640)
  const sliderRef = useRef(null)

  const fetchDestacados = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/destacados?populate[modelos][populate]=imagen_card,serie,linea`
      )
      const json = await res.json()
      if (!res.ok || !json.data) throw new Error()

      const destacados = json.data.map(item =>
        item.attributes ? { id: item.id, ...item.attributes } : item
      )
      const tarjetas = destacados
        .reduce((acc, d) => [...acc, ...d.modelos], [])
        .map(modelo => ({
          modelo: modelo.nombre || 'Sin nombre',
          slug: modelo.slug,
          imagenCard:
            modelo.imagen_card?.formats?.medium?.url ||
            modelo.imagen_card?.url ||
            '',
          serie: modelo.serie?.nombre || '',
          selectedLineaSlug: modelo.linea?.slug || ''
        }))
      setItems(tarjetas)
    } catch (err) {
      console.error('Error al obtener destacados:', err)
      setError('Error cargando los modelos destacados.')
    }
  }

  useEffect(() => {
    fetchDestacados()
  }, [])

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const mobileSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '0px',
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  }

  const desktopSettings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 200,
    cssEase: 'linear',
    pauseOnHover: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  }

  if (error) return <div className={styles.error}>{error}</div>

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h3 className={styles.title}>Recomendados</h3>
        <div className={styles.carouselWrapper}>
          <Slider
            ref={sliderRef}
            key={isMobile ? 'mobile' : 'desktop'}
            {...(isMobile ? mobileSettings : desktopSettings)}
            className={styles.carousel}
          >
            {items.length ? (
              items.map((m, i) => (
                <div key={i} className={styles.slide}>
                  <ModeloDestacadoCard
                    modelo={m.modelo}
                    slug={m.slug}
                    imagenCard={m.imagenCard}
                    selectedLineaSlug={m.selectedLineaSlug}
                  />
                </div>
              ))
            ) : (
              <div>No hay modelos destacados.</div>
            )}
          </Slider>
          {!isMobile && (
            <>
              <div className={styles.maskLeft} />
              <div className={styles.maskRight} />
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default ModeloDestacado
